var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-translate';
import { getSource, getSourceColor } from '../utils/knreise';
import { getArticleThumb } from '../utils/article';
import LoadingIndicator from '../components/LoadingIndicator';
import ArticleListComponent from '../components/ArticleListComponent';
import './ArticleList.scss';
export var ArticleList = (_temp = _class = function (_React$Component) {
  _inherits(ArticleList, _React$Component);

  function ArticleList() {
    _classCallCheck(this, ArticleList);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ArticleList.prototype.validTitle = function validTitle(title) {
    return title && title !== 'null';
  };

  ArticleList.prototype.cleanText = function cleanText(text) {
    var txt = text.replace(/<\/?[^>]+(>|$)/g, '');

    if (txt.length > 150) {
      return txt.substring(0, txt.indexOf(' ', 150));
    }

    return txt;
  };

  ArticleList.prototype.getThumbnail = function getThumbnail(article) {
    var thumbnailSize = this.props.thumbnailSize;
    var img = getArticleThumb(article, thumbnailSize || 'medium');

    if (img) {
      return img;
    }

    if (article.vimeoData) {
      return article.vimeoData.thumbnail_url;
    }
  };

  ArticleList.prototype.renderArticle = function renderArticle(article, loadImage) {
    var _props = this.props,
        t = _props.t,
        onArticleOpen = _props.onArticleOpen,
        thumbnailClassName = _props.thumbnailClassName;
    var ArticleComponent = this.props.articleComponent || ArticleListComponent;
    var source = getSource(article.sources[0]);
    var thumbnail = this.getThumbnail(article);
    var color = getSourceColor(source);
    return React.createElement(ArticleComponent, {
      key: article.id,
      article: article,
      loadImage: loadImage,
      t: t,
      onArticleOpen: onArticleOpen,
      thumbnailClassName: thumbnailClassName,
      thumbnail: thumbnail,
      color: color,
      validTitle: this.validTitle,
      cleanText: this.cleanText,
      source: source
    });
  };

  ArticleList.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        t = _props2.t,
        isLoading = _props2.isLoading,
        articles = _props2.articles,
        lazyLoad = _props2.lazyLoad;
    return React.createElement('div', {
      className: ['article-list clearfix', 'articleList--list', isLoading ? 'articleList--loading' : ''].join(' ')
    }, !isLoading && !articles.length ? React.createElement('div', {
      className: 'articleList--noResults'
    }, React.createElement('p', null, t('NoResults')), React.createElement('p', null, t('NoResultsTryChange'))) : articles.map(function (article, idx) {
      return _this2.renderArticle(article, idx < 5 || !lazyLoad);
    }), React.createElement('div', {
      className: 'articleList--loadOverlay'
    }, React.createElement(LoadingIndicator, null), t('Loading')));
  };

  return ArticleList;
}(React.Component), _class.defaultProps = {
  thumbnailClassName: 'articleList--thumbnail',
  lazyLoad: false
}, _temp);
ArticleList.propTypes = process.env.NODE_ENV !== "production" ? {
  t: PropTypes.func.isRequired,
  articles: PropTypes.array.isRequired,
  onArticleOpen: PropTypes.func.isRequired,
  thumbnailClassName: PropTypes.string,
  thumbnailSize: PropTypes.string,
  lazyLoad: PropTypes.bool,
  isLoading: PropTypes.bool,
  articleComponent: PropTypes.func
} : {};
export default translate('ArticleList')(ArticleList);